import { useState, useContext, KeyboardEvent } from 'react';
import { Button, notification } from 'antd';
import OtpInput from 'react-otp-input';

import { ConfirmProps } from './types';
import {
  AuthenticationControllerApiFactory as authAPI,
  UserResourceControllerApiFactory as userAPI
} from '../../../api_client/parameter_api';
import { handleError } from '../../../utils/handleError';
import { AppContext } from '../../../context/context';
import { setUserProfile } from '../../../context/user/actions';
import { insertTokenIntoHttp, setToken } from '../../../utils/token';
import { apiLocation } from '../../../config';
import './Confirm.less';

const Confirm = ({ confirmLogin, user }: ConfirmProps) => {
  const [, dispatch] = useContext<any>(AppContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [optValue, setOptValue] = useState<string>('');

  const handleConfirm = async () => {
    if (optValue.length === 6) {
      try {
        setLoading(true);
        const loginRes = await authAPI(undefined, apiLocation).loginToSystem(
          user.username,
          user.password,
          Number(optValue)
        );
        setLoading(false);
        if (loginRes.status === 401) {
          notification.error({ message: 'Access is denied' });
          return;
        }
        insertTokenIntoHttp(loginRes.data);
        const profileRes = await userAPI(undefined, apiLocation).getProfile();
        setToken({ token: loginRes.data, expires: loginRes.headers.expires });
        dispatch(setUserProfile(profileRes.data));
        confirmLogin({ token: loginRes.data, expires: loginRes.headers.expires, user: profileRes.data });
      } catch (err: any) {
        handleError(err);
        setLoading(false);
      }
    } else {
      notification.warning({ message: 'Not valid number' });
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleConfirm();
    }
  };

  const handleChange = (opt: string) => setOptValue(opt);

  return (
    <div className='confirm-form' onKeyDown={handleKeyDown}>
      <OtpInput
        value={optValue}
        onChange={handleChange}
        numInputs={6}
        shouldAutoFocus={true}
        inputStyle='input-box'
        containerStyle='confirm-box-container'
      />
      <Button className='confirm-btn' type='primary' htmlType='submit' onClick={handleConfirm} loading={loading}>
        Confirm
      </Button>
    </div>
  );
};

export default Confirm;
